export const DEFAULT_AVATAR = '/art/avatars-v1/otter.webp';
export const AVATAR_GROUPS = [
  {
    name: '海岛动物',
    items: [
      ['otter', '贝壳水獭'],
      ['cat', '假日橘猫'],
      ['capybara', '松弛水豚'],
      ['penguin', '泳镜企鹅'],
      ['shiba', '阳光柴犬'],
      ['rabbit', '花花白兔'],
      ['panda', '竹叶熊猫'],
      ['seal', '水手海豹'],
    ],
  },
  {
    name: '海洋伙伴',
    items: [
      ['dolphin', '跃浪海豚'],
      ['turtle', '慢游海龟'],
      ['octopus', '软糖章鱼'],
      ['whale', '蓝鲸宝宝'],
      ['clownfish', '珊瑚小鱼'],
      ['crab', '横行小蟹'],
      ['seahorse', '金色海马'],
      ['ray', '飞翼鳐鱼'],
    ],
  },
  {
    name: '森林朋友',
    items: [
      ['fox', '探险狐狸'],
      ['koala', '午睡考拉'],
      ['frog', '遮阳青蛙'],
      ['duck', '渔夫小鸭'],
      ['bear', '蜂蜜小熊'],
      ['raccoon', '水手浣熊'],
      ['hedgehog', '叶帽刺猬'],
      ['sloth', '度假树懒'],
    ],
  },
  {
    name: '奇趣岛民',
    items: [
      ['astronaut', '星际旅人'],
      ['robot', '蓝蓝机器人'],
      ['cloud', '绵绵云朵'],
      ['star', '晚安星星'],
      ['mushroom', '蘑菇精灵'],
      ['coconut', '墨镜椰子'],
      ['sprout', '新芽精灵'],
      ['jelly', '摸鱼团子'],
    ],
  },
] as const;
export const AVATAR_IDS: readonly string[] = AVATAR_GROUPS.flatMap((g) =>
  g.items.map(([id]) => id),
);
export const presetAvatar = (id: string) => `/art/avatars-v1/${id}.webp`;
